import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function TenantTaxonomy() {
  return (
    <div className="p-8">
      <h1 className="font-display text-3xl font-bold tracking-tight mb-1" data-testid="tenant-taxonomy-title">Categories & Brands</h1>
      <p className="text-slate-500 text-sm mb-6">Organise products for easy customer browsing.</p>
      <Tabs defaultValue="cats">
        <TabsList>
          <TabsTrigger value="cats" data-testid="tab-categories">Categories</TabsTrigger>
          <TabsTrigger value="brands" data-testid="tab-brands">Brands</TabsTrigger>
        </TabsList>
        <TabsContent value="cats"><Section endpoint="categories" label="Category" testid="category" /></TabsContent>
        <TabsContent value="brands"><Section endpoint="brands" label="Brand" testid="brand" /></TabsContent>
      </Tabs>
    </div>
  );
}

function Section({ endpoint, label, testid }) {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const refresh = () => api.get(`/tenant/${endpoint}`).then(({ data }) => setItems(data));
  useEffect(() => { refresh(); }, [endpoint]);
  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      const payload = endpoint === "brands" ? { name, logo: image } : { name, image };
      await api.post(`/tenant/${endpoint}`, payload);
      setName(""); setImage("");
      toast.success(`${label} added`);
      refresh();
    } catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => {
    if (!confirm("Delete?")) return;
    await api.delete(`/tenant/${endpoint}/${id}`);
    refresh();
  };
  return (
    <Card className="p-6 mt-4 border-slate-200">
      <form onSubmit={add} className="flex gap-2 mb-4">
        <Input placeholder={`${label} name`} value={name} onChange={(e) => setName(e.target.value)} data-testid={`${testid}-name-input`} />
        <Input placeholder="Image URL (optional)" value={image} onChange={(e) => setImage(e.target.value)} data-testid={`${testid}-image-input`} />
        <Button type="submit" data-testid={`${testid}-add-btn`}><Plus className="h-4 w-4" /></Button>
      </form>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">
        {items.map((i) => (
          <div key={i.id} className="border border-slate-200 rounded-md p-3 flex justify-between items-center" data-testid={`${testid}-row-${i.id}`}>
            <div className="flex items-center gap-2">
              {(i.image || i.logo) && <img src={i.image || i.logo} alt="" className="w-8 h-8 object-cover rounded" />}
              <span className="text-sm font-medium">{i.name}</span>
            </div>
            <Button variant="ghost" size="icon" onClick={() => del(i.id)} data-testid={`${testid}-delete-${i.id}`}><Trash2 className="h-4 w-4 text-rose-600" /></Button>
          </div>
        ))}
        {items.length === 0 && <p className="text-sm text-slate-400 col-span-3">None yet.</p>}
      </div>
    </Card>
  );
}
